import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// i18n — import for side effects (initialises i18next before React renders)
import '@/i18n'

// Global styles
import '@/styles/globals.css'

import { queryClient } from '@/lib/queryClient'
import { useAuthStore } from '@/store/auth'
import App from './App'

// Initialise auth store (hydrate from localStorage, wire event listeners)
useAuthStore.getState().init()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>
)
